import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IImageFile } from 'interfaces/files';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS}.${BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.EQUIPMENT}` as const;

export const EQUIPMENT_SECTION_NAMES = {
  FILE: 'file',
  NAME: 'name',
  NUMBER: 'number',
  COST: 'cost',
  PURPOSE: 'purpose',
} as const;

export interface IEquipmentSection {
  [EQUIPMENT_SECTION_NAMES.FILE]: IImageFile[];
  [EQUIPMENT_SECTION_NAMES.NAME]: string;
  [EQUIPMENT_SECTION_NAMES.NUMBER]: string;
  [EQUIPMENT_SECTION_NAMES.COST]: string;
  [EQUIPMENT_SECTION_NAMES.PURPOSE]: string;
}

export const equipmentSectionInitialValues = {
  [EQUIPMENT_SECTION_NAMES.FILE]: [],
  [EQUIPMENT_SECTION_NAMES.NAME]: '',
  [EQUIPMENT_SECTION_NAMES.NUMBER]: '',
  [EQUIPMENT_SECTION_NAMES.COST]: '',
  [EQUIPMENT_SECTION_NAMES.PURPOSE]: '',
};

export const EQUIPMENT_NAMES = {
  DESCRIPTION: 'description',
  MAIN_EQUIPMENT: 'mainEquipment',
  LEVEL_OF_UTILIZATION: 'levelOfUtilization',
  PURCHASED_EQUIPMENT: 'purchasedEquipment',
  RATIONALE_FOR_PURCHASING: 'rationaleForPurchasing',
} as const;

export interface IEquipment {
  [EQUIPMENT_NAMES.DESCRIPTION]: string;
  [EQUIPMENT_NAMES.MAIN_EQUIPMENT]: IEquipmentSection[];
  [EQUIPMENT_NAMES.LEVEL_OF_UTILIZATION]: string;
  [EQUIPMENT_NAMES.PURCHASED_EQUIPMENT]: IEquipmentSection[];
  [EQUIPMENT_NAMES.RATIONALE_FOR_PURCHASING]: string;
}

export const equipmentInitialValues = {
  [EQUIPMENT_NAMES.DESCRIPTION]: '',
  [EQUIPMENT_NAMES.MAIN_EQUIPMENT]: [equipmentSectionInitialValues],
  [EQUIPMENT_NAMES.LEVEL_OF_UTILIZATION]: '',
  [EQUIPMENT_NAMES.PURCHASED_EQUIPMENT]: [equipmentSectionInitialValues],
  [EQUIPMENT_NAMES.RATIONALE_FOR_PURCHASING]: '',
};
